import { Box, Chip } from '@mui/material';
import type { ContentFilterArgs, ContentFilters } from '../lib';

export interface ContentFilterChips {
  filters: ContentFilters;
  updateFilter: (args: ContentFilterArgs) => void;
}

export const ContentFilterChips = ({ filters, updateFilter }: ContentFilterChips) => (
  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
    {filters.kind.items
      .filter((f) => f.selected)
      .map((f) => (
        <Chip
          key={`kind-${f.value}`}
          label={`Kind: ${f.label}`}
          color="primary"
          onDelete={() => {
            const items = filters.kind.items.map((x) =>
              x.value === f.value ? { ...x, selected: false } : x,
            );
            updateFilter({ field: 'kind', items });
          }}
        />
      ))}
    {filters.tags.items
      .filter((f) => f.selected)
      .map((f) => (
        <Chip
          key={`tag-${f.value}`}
          label={`Tag: ${f.label}`}
          color="primary"
          onDelete={() => {
            const items = filters.tags.items.map((x) =>
              x.value === f.value ? { ...x, selected: false } : x,
            );
            updateFilter({ field: 'tags', items });
          }}
        />
      ))}
  </Box>
);
